import React from "react";
import "./detallerubroSsh.css";
//import { rubros } from "../../json/rubrosSsh";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
const res = await fetch('../../../JSON/rubrosSsh.json')
const rubros = await res.json()

const DetalleRubroSsh = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { nombre } = useParams();
  const rubro = rubros.find((rubro) => rubro.nombre === nombre);

  return (
    <div className="container container_detalle_rubro">
      <div className="row">
        <div className="col-12">
          <div className="rubro_titulo">
            <h3 className="title">{rubro.nombre}</h3>
            <hr className="hr-gob" />
          </div>
        </div>
      </div>
      <div className="row">
        {rubro.formatos.map((formato, index) => {
          let mostrarxlsx;
          let mostrarhtml;
          let urlXLSX;
          let urlHTML;
            if(formato.htm_liga == undefined){
              urlHTML =
            "/TransparenciaSSH/htm/a69_" + formato.html + "SSH.htm";
            } else {
              urlHTML = formato.htm_liga;
            }
            if(formato.xlsx_liga == undefined){
              urlXLSX =
              "/TransparenciaSSH/xlsx/a69_" + formato.xlsx + "SSH.xlsx";
            }else{
              urlXLSX = formato.xlsx_liga;
            }
            if(formato.xlsx!=undefined || formato.xlsx_liga!= undefined){
              mostrarxlsx="";
            }else{
              mostrarxlsx="d-none";
            }
            if(formato.html!=undefined || formato.htm_liga!= undefined){
              mostrarhtml="";
            }else{
              mostrarhtml="d-none";
            }
          return (
            <div key={index} className="col-md-4 col-12">
              <div className="rubro_container_detalle">
                <div className="detalle_rubro_nombre">
                  <h5>{formato.nombre}</h5>
                </div>
                <div className="detalle_rubro_enlaces">
                  <a className={ mostrarxlsx} href={urlXLSX} target="_blank">
                    XLSX
                  </a>
                  <a className={ mostrarhtml} href={urlHTML} target="_blank">
                    Ver Tabla
                  </a>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DetalleRubroSsh;
